import * as ProgressPrimitive from "@radix-ui/react-progress";
import { cn } from "@theprelude/core";

export const Progress = ProgressPrimitive;
export const Indicator = ProgressPrimitive.Indicator;

export const ProgressBar: React.FC<ProgressPrimitive.ProgressProps> = ({
  className,
  ...props
}) => {
  const progress = props.value ?? 0;
  return (
    <Progress.Root
      className={cn(
        "bg-secondary-background dark:bg-tertiary-background relative h-[2px] w-80 overflow-hidden rounded",
        className,
      )}
      value={props.value}
    >
      <Progress.Indicator
        className={cn(
          "bg-secondary-foreground h-full w-full -translate-x-0 transform animate-pulse transition-transform",
        )}
        style={{ transform: `translateX(-${100 - progress}%)` }}
      />
    </Progress.Root>
  );
};
